<template>
  <a-descriptions title="订阅详情" column="1" bordered>
    <a-descriptions-item label="有效期">
      {{ deal.forever ? '永久有效' : isoToUtc(deal.expiration) + '到期' }}
    </a-descriptions-item>
    <a-descriptions-item label="入口">
      <a :href="product_subscription.entry">由此进入</a>
    </a-descriptions-item>
  </a-descriptions>
</template>

<script>
import { defineComponent } from 'vue';
import { isoToUtc } from '@/utils/util.js';

export default defineComponent({
  name: 'UsableProductSubscription',
  props: {
    product_subscription: {
      type: Object,
      default: () => ({
        content: ''
      })
    },
    deal: {
      type: Object,
      default: () => ({})
    },
  },
  setup() {
    return {
      isoToUtc
    }
  }
});
</script>

<style scoped></style>
